import { ProcessedMessage } from './useProcessMessage'
import FileContext, { FileListItemDto } from '../../context/FileContext'
import { useContext } from 'react'

/**
 * Messages originating from the serfver in order to update the global File list.
 */
export type FileUpsertNotification = ProcessedMessage<{
    file: FileListItemDto
}>

/**
 * Process an file upsert event message.
 */
export default function useProcessFileUpsertNotification() {
    const fileContext = useContext(FileContext)

    return (message: FileUpsertNotification) => {
        if (message.data.file?.id === undefined) {
            return
        }

        //add / update file to global list
        fileContext.upsertFile(message.data.file)
    }
}
